<template>
    <div>
    <card title="Account Profile">
        <div class="p-4 text-center" v-if="loading">
            <loading-resource />
        </div>
        <template v-if="isBrand || isRetailLocation">
        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Company Legal Name
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="legal_name" v-model="form.legal_name">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Phone Number
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="phone_number" v-model="form.phone_number">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Address Line 1
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_first_line" v-model="form.address_first_line">
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Address Line 2
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_second_line" v-model="form.address_second_line">
            </div>
        </div>
        </template>

        <div class="form-group row" v-if="isBrand">
            <label class="col-md-4 col-form-label text-md-right">
                Company EIN
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="ein" v-model="form.ein">
            </div>
        </div>

        <template v-if="isBrand || isRetailLocation">
        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                City
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_city" v-model="form.address_city">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                ZIP code
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_zip" v-model="form.address_zip">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                State
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_state" v-model="form.address_state">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Country
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="address_country" v-model="form.address_country">
            </div>
        </div>
        </template>

        <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">
                Friendly Company Name
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="name" v-model="form.name">
            </div>
        </div>

        <div class="form-group row" v-if="isBrand || isRetailLocation">
            <label class="col-md-4 col-form-label text-md-right">
                Company URL
            </label>

            <div class="col-md-6">
                <input type="text" readonly class="form-control" name="url" v-model="form.url">
            </div>
        </div>
    </card>

    <organizations-working-hours v-if="isRetailLocation && form.working_hours && form.working_hours.length" :working-hours="form.working_hours" />

    </div>

</template>

<script>
import { organizationsClient } from '../../../../services';
import Card from '../../../general/Card.vue';
import LoadingResource from '../../../general/LoadingResource.vue';
import OrganizationsWorkingHours from './OrganizationsWorkingHours.vue';

export default {
    components: {
        LoadingResource,
        Card,
        OrganizationsWorkingHours
    },
    props: {
        team: {
            required: true
        },
    },
    data() {
        return {
            form: {},
            loading: false
        }
    },
    computed: {
        isBrand() {
            return this.team.organization_type === 'brand';
        },
        isOnlineStore() {
            return this.team.organization_type === 'online_store';
        },
        isRetailLocation() {
            return this.team.organization_type === 'retail_location'
        },
    },
    mounted() {
        this.getOrganization()
    },
    methods: {
        getOrganization() {
            this.loading = true;

            organizationsClient.getOrganization(this.team.id)
            .then(response => this.form = response.data)
            .catch(error => {
                console.error(error)
                this.$toasted.global.platform_error();
            }).finally(() => this.loading = false)
        }
    }

};
</script>
